import { all, call, put, takeEvery } from 'redux-saga/effects';
import {fetchLessonData, addLesson, updateLesson, removeLesson} from "../service/api";
import {getAllLessonsAction} from "./general";

const UPDATE_SEARCH_TERMS = 'pv-kultu/lessonsEdit/UPDATE_SEARCH_TERMS';
const SELECT_LESSON = 'pv-kultu/lessonsEdit/SELECT_LESSON';
const GET_LESSON_FAILED = 'pv-kultu/lessonsEdit/GET_LESSON_FAILED';
const GET_LESSON_SUCCESS = 'pv-kultu/lessonsEdit/GET_LESSON_SUCCESS';
const NEW_LESSON_EDIT = 'pv-kultu/lessonsEdit/NEW_LESSON_EDIT';
const CLEAR_EDIT = 'pv-kultu/lessonsEdit/CLEAR_EDIT';
const UPDATE_CHANGES = 'pv-kultu/lessonsEdit/UPDATE_CHANGES';
const SAVE_LESSON = 'pv-kultu/lessonsEdit/SAVE_LESSON';
const EDIT_LESSON_SUCCESS = 'pv-kultu/lessonsEdit/EDIT_LESSON_SUCCESS';
const EDIT_LESSON_FAILURE = 'pv-kultu/lessonsEdit/EDIT_LESSON_FAILURE';
const LESSON_EDIT_SHOWN = 'pv-kultu/lessonsEdit/LESSON_EDIT_SHOWN';
const LESSON_REMOVE = 'pv-kultu/lessonsEdit/LESSON_REMOVE';


// Initial state
const initialState = {
  searchTerms : {},
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_SEARCH_TERMS:
      return Object.assign({}, state, { searchTerms: Object.assign({}, state.searchTerms, action.terms)});
    case SELECT_LESSON:
      return Object.assign({}, state, {
        loadingLesson: true
      });
    case GET_LESSON_SUCCESS:
      return Object.assign({}, state, {
        loadingLesson: false,
        lessonEdited: action.lesson,
      });
    case GET_LESSON_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    case CLEAR_EDIT:
      return Object.assign({}, state, {
        loadingLesson: false,
        lessonEdited:  null});
    case UPDATE_CHANGES:
      return Object.assign({}, state, {lessonEdited: Object.assign({}, state.lessonEdited, action.lessonChange)});
    case NEW_LESSON_EDIT:
      return Object.assign({}, state, {lessonEdited: {}});
    case SAVE_LESSON:
      return Object.assign({}, state, {
        loadingLesson: true,
        editType: 'SAVE'
      });
    case LESSON_REMOVE:
      return Object.assign({}, state, {
        loadingLesson: true,
        editType: 'REMOVE'
      });
    case EDIT_LESSON_SUCCESS:
      return Object.assign({}, state, {
        loadingLesson: false,
        lessonSavedInfo: true,
        lessonEdited: null,
        lessons: action.lessons
      });
    case EDIT_LESSON_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loadingLesson:false,
        savingLessonError: action.error,
        lessonSavedInfo: true,
        lessonEdited:null,
      });
    case LESSON_EDIT_SHOWN:
      return Object.assign({}, state, {
        lessonSavedInfo: false,
        savingLessonError: null,
        editType: undefined,
      });
    default:
      return state;
  }
}

// Actions
export function updateSearchTermsAction(searchTerms) {
  return {type: UPDATE_SEARCH_TERMS, terms: searchTerms}
}
export function selectLessonAction(entityId) {
  return {type: SELECT_LESSON, entityId: entityId}
}

export function getLessonSuccessAction(lesson) {
  return {type: GET_LESSON_SUCCESS, lesson: lesson}
}

export function getLessonFailedAction(error) {
  return {type: GET_LESSON_FAILED, error: error}
}
export function newLessonEditedAction(){
  return {type: NEW_LESSON_EDIT}
}

export function clearEditAction() {
  return {type: CLEAR_EDIT}
}

export function updateLessonChangesAction(lessonChange) {
  return {type: UPDATE_CHANGES, lessonChange: lessonChange}
}

export function saveLessonAction(lesson) {
  return {type: SAVE_LESSON, lesson:lesson}
}
export function editLessonSuccessAction(lesson) {
  return {type: EDIT_LESSON_SUCCESS, lesson: lesson}
}
export function editLessonFailureAction(error) {
  return {type: EDIT_LESSON_FAILURE, error:error}
}
export function lessonEditShownAction () {
  return {type:LESSON_EDIT_SHOWN}
}

export function lessonRemoveAction (lessonId) {
  return {type: LESSON_REMOVE, lessonId: lessonId}
}

// Sagas
export function * selectLessonSaga(action) {
  try {
    const response = yield call(fetchLessonData, action.entityId);
    yield put(getLessonSuccessAction(response));
  }
  catch (error) {
    yield put(getLessonFailedAction(error));
  }
}

export function * lessonSaveSaga(action) {

  try {
    let response =  !!action.lesson.entityId? yield call(updateLesson, action.lesson.entityId, action.lesson) :
      yield call(addLesson, action.lesson);

    yield put(editLessonSuccessAction(response));

  }
  catch (error) {
    yield put(editLessonFailureAction(error));
  }
}

export function * fetchLessonsSaga() {

  yield put (getAllLessonsAction());
}

export function * lessonRemoveSaga(action) {
  try {
    let response =  yield call(removeLesson, action.lessonId);

    yield put(editLessonSuccessAction(response));

  }
  catch (error) {
    yield put(editLessonFailureAction(error));
  }
}

function* watchLessonEdit() {
  yield takeEvery(SELECT_LESSON, selectLessonSaga);
  yield takeEvery(SAVE_LESSON, lessonSaveSaga);
  yield takeEvery(EDIT_LESSON_SUCCESS, fetchLessonsSaga);
  yield takeEvery(EDIT_LESSON_FAILURE, fetchLessonsSaga);
  yield takeEvery(LESSON_REMOVE, lessonRemoveSaga);

}

export function* lessonEditSagas() {
  yield all([
    watchLessonEdit(),
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/lessonsEdit.js